import { request } from '../request';

export function fetchGetApplictionList(params?: Api.SystemManage.ApplicationParams) {
  return request<Api.SystemManage.ApplicationList>({
    url: '/developer-platform/api/application/query/listTemplates',
    method: 'GET',
    params
  });
}

export function fetchPostAddAppliction(data?: Api.SystemManage.ApplicationForm) {
  return request<any>({
    url: '/developer-platform/api/application/template/add',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  });
}

export function fetchGetAddApplictionDetail(id: string) {
  return request<any>({
    url: '/developer-platform/api/application/template/get',
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      id
    }
  });
}

// 更新应用模板
export function fetchPostUpdateAppliction(data?: Api.SystemManage.ApplicationForm) {
  return request<any>({
    url: '/developer-platform/api/application/template/update',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  });
}

// 模板-设置应用模板发布状态
export function fetchSetReleaseStatus(data?: any) {
  return request<any>({
    url: '/developer-platform/api/application/template/setReleaseStatus',
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: data
  });
}

export function fetchGetServiceConfig(id: string) {
  return request<any>({
    url: '/developer-platform/api/application/template/getServiceConfig',
    method: 'GET',
    params: {
      id
    }
  });
}

// 删除模板配置
export function fetchDelServiceConfig(data?: any) {
  return request<any>({
    url: '/developer-platform/api/application/template/delConfig',
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: data
  });
}
// 设置sms服务配置
export function fetchSetSmsServiceConfig(data?: any) {
  return request<any>({
    url: '/developer-platform/api/application/template/setSmsServiceConfig',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  });
}

// 设置邮箱服务配置
export function fetchSetEmailServiceConfig(data?: Api.SystemManage.emailConfig) {
  return request<any>({
    url: '/developer-platform/api/application/template/setEmailServiceConfig',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  });
}

// 获取验证码模板
export function fetchGetCaptchaTemplate(id: string) {
  return request<any>({
    url: '/developer-platform/api/application/template/getCaptchaTemplate',
    method: 'GET',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      id
    }
  });
}

// 设置短信验证码模板
export function fetchSetSmsCaptchaTemplate(data?: any) {
  return request<any>({
    url: '/developer-platform/api/application/template/setSmsCaptchaTemplate',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  });
}

// 设置邮箱验证码模板
export function fetchSetEmailCaptchaTemplate(data?: any) {
  return request<any>({
    url: '/developer-platform/api/application/template/setEmailCaptchaTemplate',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  });
}

// 获取推送配置
export function fetchGetPushConfig(id: string) {
  return request<any>({
    url: '/developer-platform/api/application/template/getPushConfig',
    method: 'GET',
    params: {
      id
    }
  });
}

// 设置Android消息推送配置
export function fetchSetAndroidPushConfig(data?: any) {
  return request<any>({
    url: '/developer-platform/api/application/template/setAndroidPushConfig',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  });
}

// 设置IOS消息推送配置
export function fetchSetIosPushConfig(data?: any) {
  return request<any>({
    url: '/developer-platform/api/application/template/setIosPushConfig',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  });
}

// 以下为  应用列表数据
export function fetchApplicationList(params?: any) {
  return request<any>({
    url: '/developer-platform/api/application/query/list',
    method: 'GET',
    params
  });
}

// 设置应用模板启用状态
export function fetchSetEnableStatus({ id, status }: { id: any; status: any }) {
  return request<any>({
    url: '/developer-platform/api/application/template/setEnableStatus',
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      id,
      status
    }
  });
}

/**
 * 应用配置 获取个人信息配置
 *
 * @param params
 * @returns
 */
export function fetchGetAppPersonalInfoSetting(params: any) {
  return request<any>({
    url: '/developer-platform/api/application/config/personalInfoSetting',
    method: 'GET',
    params
  });
}

/**
 * 应用配置 设置个人信息配置
 *
 * @param data
 * @returns
 */
export function fetchPostEditAppPersonalInfoSetting(data: any) {
  return request<any>({
    url: '/developer-platform/api/application/config/personalInfoSetting/set',
    method: 'POST',
    data
  });
}

/**
 * 应用配置 删除个人信息配置
 *
 * @param settingId
 * @returns
 */
export function fetchPostDeleteAppPersonalInfoSetting(settingId: number) {
  return request<any>({
    url: '/developer-platform/api/application/config/personalInfoSetting/remove',
    method: 'POST',
    params: {
      settingId
    }
  });
}

/**
 * 应用配置 获取可选个人信息配置
 *
 * @param id
 * @returns
 */
export function fetchGetOptionalAppPersonalInfoSetting(id: number) {
  return request<any>({
    url: '/developer-platform/api/application/config/personalInfoSetting/optional/list',
    method: 'GET',
    params: {
      id
    }
  });
}

export function fetchPostAddPersonalInfoSetting(data: any) {
  return request<any>({
    url: '/developer-platform/api/application/config/addPersonalInfoConfig',
    method: 'POST',
    data
  });
}
